<template>
  <section id="accessories" class="prices-acc" ref="root">
    <div class="prices-acc__inner" :class="{ 'prices-acc__inner_visible': inView }">
      <p v-if="false" class="prices-acc__lead">
        Картины крупного формата могут дополняться аксессуарами, усиливающими образ и смысл композиции:
        <span class="prices-acc__tag">часы</span>, <span class="prices-acc__tag">ключи от авто</span>, <span class="prices-acc__tag">браслеты</span> и другие элементы статуса и ценности.
      </p>
      <h2 class="prices-acc__title">По желанию мы можем:</h2>
      <div class="prices-acc__row">
        <div class="prices-acc__card" :class="'prices-acc__card_' + (i + 1)" v-for="(item, i) in options" :key="item.text" :style="{ transitionDelay: `${0.1 + i * 0.08}s` }">
          <span class="prices-acc__card-icon" v-html="item.icon" aria-hidden="true" />
          <span class="prices-acc__card-text">{{ item.text }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'

export default {
  name: 'PricesAccessories',
  setup() {
    const root = ref(null)
    const inView = ref(false)
    let observer = null

    const options = [
      {
        text: 'Добавить индивидуальную надпись (входит в стоимость)',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>`
      },
      {
        text: 'Адаптировать общую концепцию и визуальную схему под вас (в рамках размера вашей картины)',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="13.5" cy="6.5" r=".5"/><circle cx="17.5" cy="10.5" r=".5"/><circle cx="8.5" cy="7.5" r=".5"/><circle cx="6.5" cy="12.5" r=".5"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.648 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.649-1.649h1.649c4.051 0 7.375-3.297 7.375-7.348C22 6.5 17.5 2 12 2z"/></svg>`
      },
      {
        text: 'Сроки изготовления картины 5-7 дней (в зависимости от сложности и количества элементов)',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>`
      },
      {
        text: 'Доставку вы оплачиваете отдельно (обсуждаем конкретно для вас)',
        icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>`
      }
    ]

    onMounted(() => {
      observer = new IntersectionObserver(
        ([e]) => { if (e.isIntersecting) inView.value = true },
        { threshold: 0.15 }
      )
      if (root.value) observer.observe(root.value)
    })
    onUnmounted(() => observer?.disconnect())

    return { root, inView, options }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";

$dur: 0.65s;
$ease: cubic-bezier(0.22, 1, 0.36, 1);

.prices-acc {
  position: relative;
  padding: 80px $gap 0;
  background: $color-bg;
  scroll-margin-top: 80px;

  @media (max-width: $breakpoint-tablet) {
    scroll-margin-top: 72px;
  }

  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23000000' fill-opacity='0.04'%3E%3Ccircle cx='4' cy='4' r='1.5'/%3E%3Ccircle cx='20' cy='4' r='1.5'/%3E%3Ccircle cx='4' cy='20' r='1.5'/%3E%3Ccircle cx='20' cy='20' r='1.5'/%3E%3C/g%3E%3C/svg%3E");
    pointer-events: none;
  }

  @media (max-width: $breakpoint-mobile) {
    padding: 56px $gap 0;
  }

  &__inner {
    position: relative;
    z-index: 1;
    max-width: $container-max;
    margin: 0 auto;
  }

  &__lead {
    font-size: clamp(17px, 1.9vw, 20px);
    line-height: 1.6;
    color: $color-text;
    margin: 0 0 48px;
    max-width: 720px;
    opacity: 0;
    transform: translateY(20px);
    transition: opacity $dur $ease, transform $dur $ease;

    .prices-acc__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__tag {
    display: inline-block;
    padding: 2px 10px;
    margin: 0 2px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    font-weight: 700;
    color: $color-text;
  }

  &__title {
    font-size: clamp(18px, 2vw, 22px);
    font-weight: 700;
    color: $color-text;
    margin: 0 0 24px;
    opacity: 0;
    transform: translateY(16px);
    transition: opacity $dur $ease 0.06s, transform $dur $ease 0.06s;

    .prices-acc__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &__row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin: 0 0 48px;

    @media (max-width: $breakpoint-mobile) {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }

  &__card {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    padding: 24px 28px;
    background: #f5f5f5;
    border: 2px solid $color-border;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    opacity: 0;
    transform: translateY(16px);
    transition: opacity $dur $ease, transform $dur $ease, border-color 0.2s, box-shadow 0.2s;

    &:hover {
      border-color: rgba(0, 0, 0, 0.15);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
    }

    .prices-acc__inner_visible & {
      opacity: 1;
      transform: translateY(0);
    }

    @media (max-width: $breakpoint-mobile) {
      padding: 20px 22px;
      gap: 16px;
    }
  }

  &__card-icon {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    background: $color-primary;
    color: $color-primary-inverse;
    border-radius: 10px;

    :deep(svg) {
      width: 24px;
      height: 24px;
    }

    .prices-acc__card_1 & {
      background: $color-accent-teal;
      color: #fff;
    }

    .prices-acc__card_2 & {
      background: $color-accent-violet;
      color: #fff;
    }
  }

  &__card-text {
    font-size: clamp(15px, 1.6vw, 17px);
    font-weight: 600;
    line-height: 1.4;
    color: $color-text;
    padding-top: 4px;
  }
}
</style>
